// Import all translations
import { adminDashboardAr } from './adminDashboard.ar';
import { adminDashboardFr } from './adminDashboard.fr';
import { adminDashboardEn } from './adminDashboard.en';
import { homeAr } from './home.ar';
import { homeFr } from './home.fr';
import { homeEn } from './home.en';
import { parentDashboardAr } from './parentDashboard.ar';
import { parentDashboardFr } from './parentDashboard.fr';
import { parentDashboardEn } from './parentDashboard.en';
import { teacherDashboardAr } from './teacherDashboard.ar';
import { teacherDashboardFr } from './teacherDashboard.fr';
import { teacherDashboardEn } from './teacherDashboard.en';
import { loginAr } from './login.ar';
import { loginFr } from './login.fr';
import { loginEn } from './login.en';
import { quranTrackingAr } from './quranTracking.ar';
import { quranTrackingFr } from './quranTracking.fr';
import { quranTrackingEn } from './quranTracking.en';
import { getParameterNameAr } from './parameters.ar';
import { getParameterNameFr } from './parameters.fr';
import { getParameterNameEn } from './parameters.en';

// Export all translations
export { adminDashboardAr } from './adminDashboard.ar';
export { adminDashboardFr } from './adminDashboard.fr';
export { adminDashboardEn } from './adminDashboard.en';
export { homeAr } from './home.ar';
export { homeFr } from './home.fr';
export { homeEn } from './home.en';
export { parentDashboardAr } from './parentDashboard.ar';
export { parentDashboardFr } from './parentDashboard.fr';
export { parentDashboardEn } from './parentDashboard.en';
export { teacherDashboardAr } from './teacherDashboard.ar';
export { teacherDashboardFr } from './teacherDashboard.fr';
export { teacherDashboardEn } from './teacherDashboard.en';
export { loginAr } from './login.ar';
export { loginFr } from './login.fr';
export { loginEn } from './login.en';
export { quranTrackingAr } from './quranTracking.ar';
export { quranTrackingFr } from './quranTracking.fr';
export { quranTrackingEn } from './quranTracking.en';
export { hadithTranslations } from './hadiths';

// Combined translations objects
export const adminDashboardTranslations = {
  ar: adminDashboardAr,
  fr: adminDashboardFr,
  en: adminDashboardEn,
};

export const homeTranslations = {
  ar: homeAr,
  fr: homeFr,
  en: homeEn,
};

export const parentDashboardTranslations = {
  ar: { ...parentDashboardAr, ...teacherDashboardAr },
  fr: { ...parentDashboardFr, ...teacherDashboardFr },
  en: { ...parentDashboardEn, ...teacherDashboardEn },
};

export const teacherDashboardTranslations = {
  ar: teacherDashboardAr,
  fr: teacherDashboardFr,
  en: teacherDashboardEn,
};

export const loginTranslations = {
  ar: loginAr,
  fr: loginFr,
  en: loginEn,
};

export const quranTrackingTranslations = {
  ar: quranTrackingAr,
  fr: quranTrackingFr,
  en: quranTrackingEn,
};

export const getParameterName = {
  ar: getParameterNameAr,
  fr: getParameterNameFr,
  en: getParameterNameEn,
};

